// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"TextBlock_textBlock__1EJiN","texts":"TextBlock_texts__6zEPz","textItem":"TextBlock_textItem__mC9nI"};